import { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';
import { isD2cModelVsp } from '@core/Utils/Vehicle/isD2cModelVsp';
import { AllFlags } from '@growthBookExperimentation/Entities/FlagKeys.entities';

type Props = {
  flags: AllFlags;
  vehicle: Vehicle | null;
};

export const getAdminFee = ({ flags, vehicle }: Props) => {
  if (!vehicle) {
    return {
      shouldShowEcomAdminFee: false,
      shouldShowD2cAdminFee: false,
    };
  }

  const isEcom = vehicle?.ecom?.isEcom;
  const isD2C = isD2cModelVsp(vehicle);
  const isEcomAndNotD2C = !!(isEcom && !isD2C);
  const shouldShowEcomAdminFee = flags?.adminFeeEcom && isEcomAndNotD2C;
  const shouldShowD2cAdminFee = flags?.adminFeeD2c && isD2C;

  return {
    shouldShowEcomAdminFee,
    shouldShowD2cAdminFee,
  };
};
